<script setup lang="ts">
/**
 * Error page for `ErrorCode.InvalidStateInAuthResponse` — CSRF state mismatch
 * in the OAuth callback. The `state` parameter returned by Keycloak did not
 * match the value saved in `sessionStorage` before the redirect, indicating
 * a possible CSRF or session-fixation attempt. Delegates all rendering to
 * `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.InvalidStateInAuthResponse" />
</template>
